import {
	GET_USER_MANAGEMENT_LIST,
	GET_USER_MANAGEMENT_LIST_SUCCESS,
	GET_USER_MANAGEMENT_LIST_FAILED,
	GET_USER_MANAGEMENT_LIST_RESET,
	POST_CREATE_USER_REQUEST,
	POST_CREATE_USER_REQUEST_SUCCESS,
	POST_CREATE_USER_REQUEST_FAILED,
	POST_CREATE_USER_REQUEST_RESET,
	DELETE_USER_REQUEST,
	DELETE_USER_REQUEST_SUCCESS,
	DELETE_USER_REQUEST_FAILED,
	DELETE_USER_REQUEST_RESET,
	EMAIL_AVAILABILITY_CHECK,
	EMAIL_AVAILABILITY_CHECK_SUCCESS,
	EMAIL_AVAILABILITY_CHECK_FAILED,
	EMAIL_AVAILABILITY_CHECK_RESET,
	UPDATE_USER_REQUEST,
	UPDATE_USER_REQUEST_SUCCESS,
	UPDATE_USER_REQUEST_FAILED,
	UPDATE_USER_REQUEST_RESET,
	GET_CASE_ACCESS_LIST,
	GET_CASE_ACCESS_LIST_SUCCESS,
	GET_CASE_ACCESS_LIST_FAIL,
	GET_CASE_ACCESS_LIST_RESET,
} from "../types"

export const getUsersList = (data) => ({
	type: GET_USER_MANAGEMENT_LIST,
	payload: data,
})

export const getUsersListSuccess = (data) => ({
	type: GET_USER_MANAGEMENT_LIST_SUCCESS,
	payload: data,
})

export const getUsersListFailed = (data) => ({
	type: GET_USER_MANAGEMENT_LIST_FAILED,
	payload: data,
})

export const getUsersListReset = () => ({
	type: GET_USER_MANAGEMENT_LIST_RESET,
})

export const createUser = (data) => ({
	type: POST_CREATE_USER_REQUEST,
	payload: data,
})

export const createUserSuccess = (data) => ({
	type: POST_CREATE_USER_REQUEST_SUCCESS,
	payload: data,
})

export const createUserFailed = (data) => ({
	type: POST_CREATE_USER_REQUEST_FAILED,
	payload: data,
})

export const createUserReset = () => ({
	type: POST_CREATE_USER_REQUEST_RESET,
})

export const deleteUser = (data) => ({
	type: DELETE_USER_REQUEST,
	payload: data,
})

export const deleteUserSuccess = (data) => ({
	type: DELETE_USER_REQUEST_SUCCESS,
	payload: data,
})

export const deleteUserFailed = (data) => ({
	type: DELETE_USER_REQUEST_FAILED,
	payload: data,
})

export const deleteUserReset = () => ({
	type: DELETE_USER_REQUEST_RESET,
})

export const emailAvailabilityCheck = (data) => ({
	type: EMAIL_AVAILABILITY_CHECK,
	payload: data,
})

export const emailAvailabilityCheckSuccess = (data) => ({
	type: EMAIL_AVAILABILITY_CHECK_SUCCESS,
	payload: data,
})

export const emailAvailabilityCheckFailed = (data) => ({
	type: EMAIL_AVAILABILITY_CHECK_FAILED,
	payload: data,
})

export const emailAvailabilityCheckReset = () => ({
	type: EMAIL_AVAILABILITY_CHECK_RESET,
})

export const updateUser = (data) => ({
	type: UPDATE_USER_REQUEST,
	payload: data,
})

export const updateUserSuccess = (data) => ({
	type: UPDATE_USER_REQUEST_SUCCESS,
	payload: data,
})

export const updateUserFailed = (data) => ({
	type: UPDATE_USER_REQUEST_FAILED,
	payload: data,
})

export const updateUserReset = () => ({
	type: UPDATE_USER_REQUEST_RESET,
})

export const getCaseAccessList = (data) => ({
	type: GET_CASE_ACCESS_LIST,
	payload: data,
})

export const getCaseAccessListSuccess = (data) => ({
	type: GET_CASE_ACCESS_LIST_SUCCESS,
	payload: data,
})

export const getCaseAccessListFailed = (data) => ({
	type: GET_CASE_ACCESS_LIST_FAIL,
	payload: data,
})

export const getCaseAccessListReset = () => ({
	type: GET_CASE_ACCESS_LIST_RESET,
})
